import * as React from 'react';
import {
  Logging,
  API,
  ResponseError,
  NotificationData,
  Setting,
  CertificateSettingsContext,
  SettingsCollection,
} from '@vcd-ecm-ui/Common';
import { useDispatch } from 'react-redux';
import { createCertificateSettingsObject } from '../../Common/Common';

const useCertificateSettings = (
  gatewayEndPoint: string,
): [Setting[], CertificateSettingsContext, NotificationData] => {
  const [certificateSettings, setCertificateSettings] = React.useState(null);
  const [certificateSettingsObject, setCertificateSettingsObject] = React.useState(null);
  const [certificateSettingsNotification, setCertificateSettingsNotification] = React.useState(null);
  const dispatch = useDispatch();

  const getCertificateSettings = () => async (): Promise<void> => {
    try {
      const api = new API(gatewayEndPoint);

      const settingsCollection: SettingsCollection = await api.settings.getCertificateSettingsV4();
      const settings: Setting[] = settingsCollection.value;

      Logging.Debug('Get Certificate Settings:', settings);

      // Update the Certificate Settings Object
      const settingsObject: CertificateSettingsContext = createCertificateSettingsObject(settings);

      setCertificateSettings(settings);
      setCertificateSettingsObject(settingsObject);
    } catch (error) {
      const notification: NotificationData = {
        type: 'Error',
        title: 'Certificate Settings Read Error',
        description: 'Unable to read Certificate Settings',
        error: error as ResponseError,
      };
      setCertificateSettingsNotification(notification);
    }
  };

  React.useEffect(() => {
    if (!certificateSettings) {
      dispatch(getCertificateSettings());
    }

    return (): void => {
      // This Code will run once the component unmounts.
      setCertificateSettings(null);
      setCertificateSettingsObject(null);
      setCertificateSettingsNotification(null);
    };
  }, []);

  return [certificateSettings, certificateSettingsObject, certificateSettingsNotification];
};

export default useCertificateSettings;
